import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

import Home from './views/Home.vue';
import Login from './views/Login.vue';
import RequestPasswordReset from './views/RequestPasswordReset.vue';
import ResetPassword from './views/ResetPassword.vue';
import Aligners from './views/Aligners.vue';
import Radar from './views/Radar.vue';
import SupportTickets from './views/SupportTickets.vue';
import Audits from './views/Audits.vue';
import SoftwareUpdates from './views/SoftwareUpdates.vue';
import Users from './views/Users.vue';
import Notifications from './views/Notifications.vue';
import Messaging from './views/Messaging.vue';
import TrendChart from './views/TrendChart.vue';
import Easy2 from './views/Easy2.vue';
import TruPoint from './views/TruPoint.vue';
import CameraCal from './views/CameraCal.vue';
import UpdateScheduler from './views/UpdateScheduler.vue';
import AIKnow from './views/AIKnow.vue';
import SpecUpdates from './views/SpecUpdates.vue';
import websocket from './websocket';

Vue.use(Router);

function ifNotAuthenticated(to, from, next) {
  if (store.getters.isAuthenticated) {
    next('/');
  } else {
    next();
  }
}

function ifAuthenticated(to, from, next) {
  if (websocket.connected === false) {
    websocket.connect();
  }

  if (store.getters.isAuthenticated) {
    next();
  } else {
    next('/login');
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/request_password_reset',
      name: 'RequestPasswordReset',
      component: RequestPasswordReset,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/reset_password',
      name: 'ResetPassword',
      component: ResetPassword,
      props: (route) => {
        return {
          token: route.query.token,
        };
      },
      beforeEnter: ifNotAuthenticated,
    },

    {
      path: '/Aligners',
      name: 'Aligners',
      component: Aligners,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Radar',
      name: 'Radar',
      component: Radar,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/TrendChart',
      name: 'TrendChart',
      component: TrendChart,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Easy',
      name: 'Easy',
      component: Easy2,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/TruPoint',
      name: 'TruPoint',
      component: TruPoint,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/SupportTickets',
      name: 'SupportTickets',
      component: SupportTickets,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Audits',
      name: 'Audits',
      component: Audits,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/SoftwareUpdates',
      name: 'SoftwareUpdates',
      component: SoftwareUpdates,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/SpecUpdates',
      name: 'SpecUpdates',
      component: SpecUpdates,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/UpdateScheduler',
      name: 'UpdateScheduler',
      component: UpdateScheduler,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Users',
      name: 'Users',
      component: Users,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Notifications',
      name: 'Notifications',
      component: Notifications,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Messaging',
      name: 'Messaging',
      component: Messaging,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/CameraCal',
      name: 'CameraCal',
      component: CameraCal,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/AIKnow',
      name: 'AIKnow',
      component: AIKnow,
      beforeEnter: ifAuthenticated,
    },
  ],
});
